// The number on a filter chip, as a small badge. Nothing for 0: an empty tab shows no "0" (D80).
export function ChipCount({ n }: { n: number | null | undefined }) {
  if (!n) return null;
  return (
    <span class="chip__count" dir="ltr">
      {n}
    </span>
  );
}
